import Button, { type ButtonProps } from '@mui/material/Button';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

const ButtonLinkInner = forwardRef<HTMLAnchorElement, ButtonProps<'a'>>((props, ref) => {
    return <Button ref={ref} component="a" {...props} />;
});

ButtonLinkInner.displayName = 'ButtonLinkInner';

export const ButtonLink = createLink(ButtonLinkInner);
